"use client"
import Image from "next/image";
import BreadCrumb from "../BreadCrumb";
import { usePanelTitleHandler } from "@/hooks";

export const PanelLayout = ({ extraClass, children, title }) => {
  const { sectionName } = children.props || ''
  const { breadCrumb } = usePanelTitleHandler({ sectionName })
  return (
    <>
      {((!sectionName || sectionName == 'dinamicPage') || (breadCrumb && sectionName)) && <BreadCrumb />}
      <div className={`${extraClass ?? ''} items-center bg-[#FAF4FF]  relative w-full flex flex-col py-24`} >
        <div className="absolute inset-0 z-0">
          <Image src="/images/bg-pink.png" fill className="object-cover" quality={55} alt="Background" />
        </div>
        <div className="relative z-1">
          {children}
        </div>
      </div>
    </>
  );
};